<template>
    <div class="home-promo-section" v-if="indexPage != null">
        <div class="container">
            <div class="promo-carousel">
                <swiper :options="swiperOption" ref="promoCarousel">
                    <swiper-slide v-for="(slide, index) in indexPage.main_promo" :key="index">
                        <div class="promo-pic" :style="!isMobileChecker ? 'background-image: url(' + slide.img + ')' : 'background-image: url(' + slide.img_mobile + ')'">
                            <div class="slide-info">
                                <strong>{{ slide.project.name }}</strong>
                                <p v-html="slide.desc"></p>
                            </div>
                            <router-link :to="{ name: 'sales-card' , params:{'id' : slide.project.slug}}" class="btn-more btn-wow-effect-hover">
                                <span v-if="globalLang == ''">Подробнее</span>
                                <span v-if="globalLang == 'kz/'">Толығырақ</span>
                                <svgIcon name="arrow-right" class="icon-right-arrow"/>
                            </router-link>
                        </div>
                    </swiper-slide>
                </swiper>

                <div class="swiper-controls promo-controls">
                    <div class="promo-btn-prev slider-btn btn-wow-effect-hover">
                        <svgIcon name="arrow-left" class="icon-left-arrow"/>
                    </div>
                    <div class="promo-btn-next slider-btn btn-wow-effect-hover">
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </div>
                <div class="swiper-pagination promo-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-promo-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.promo-btn-next',
                        prevEl: '.promo-btn-prev',
                    },
                    pagination: {
                        el: '.promo-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-promo.scss';
    @import '@/styles/components/home-page/respond/home-promo-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>